// React hook that binds the loop's subscriber surface to React's
// useSyncExternalStore. The loop module owns the state; this is just
// the React adapter. Panels call useLoopState() and re-render whenever
// the loop notifies (any guess / cord pull / lifecycle transition).

import { useSyncExternalStore } from "react";
import { getState, subscribe, type State } from "./andon-loop";

export function useLoopState(): Readonly<State> {
  return useSyncExternalStore(
    (onChange) => subscribe(() => onChange()),
    getState,
    getState,
  );
}
